import React, { useState, memo } from 'react';
import { Snowflake as SnowflakeIcon, Flame as FlameIcon, Moon as MoonIcon, HandIcon, CheckCircleIcon, UserIcon, ShieldIcon, AwardIcon } from 'lucide-react';
import { trackAddToCart } from './MetaPixel';
const Benefits = () => {
  const handleCTAClick = () => {
    // Registrar evento de Add to Cart
    trackAddToCart();
    // Abrir el checkout en la misma página
    window.location.href = 'https://shopysv.com/products/pide-tu-gorro-anti-migrana';
  };
  // Estado para los beneficios con hover
  const [hoveredBenefit, setHoveredBenefit] = useState(null);
  // Datos estadísticos para mostrar
  const stats = [{
    label: 'Usuarios satisfechos',
    value: '12,000+',
    icon: <UserIcon size={16} data-id="element-19" />
  }, {
    label: 'Países',
    value: '17',
    icon: <ShieldIcon size={16} data-id="element-20" />
  }, {
    label: 'Años de investigación',
    value: '5+',
    icon: <AwardIcon size={16} data-id="element-21" />
  }];
  return <section id="benefits" className="py-16 md:py-24 bg-white" data-id="element-22">
      <div className="container mx-auto px-4 md:px-6" data-id="element-23">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-24">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-[#1e293b]" data-id="element-25">
            Ataca la causa desde 4 frentes
          </h2>
          <p className="text-xl text-[#4a5568]" data-id="element-26">
            Esta tecnología ya está ayudando a miles de personas a encontrar
            alivio real desde casa, de forma natural y segura. Respaldada por
            especialistas, validada por más de 12,000 usuarios en 17 países, y
            con resultados que muchas personas comienzan a sentir desde las
            primeras aplicaciones.
          </p>
          {/* Estadísticas con números dinámicos */}
          <div className="flex flex-wrap justify-center gap-8 mt-8" data-id="element-27">
            {stats.map((stat, index) => <div key={index} className="flex flex-col items-center" data-id="element-28">
                <div className="bg-[#eef2ff] rounded-full p-2 mb-2" data-id="element-29">
                  {stat.icon}
                </div>
                <div className="text-2xl font-bold text-[#6366f1]" data-id="element-30">
                  {stat.value}
                </div>
                <div className="text-sm text-[#4a5568]" data-id="element-31">{stat.label}</div>
              </div>)}
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-32">
          <div className={`bg-[#f8f9ff] p-8 rounded-xl shadow-md transition-all duration-300 ${hoveredBenefit === 0 ? 'shadow-xl transform scale-105 border-2 border-[#6366f1]' : 'hover:shadow-lg hover:transform hover:scale-105'}`} onMouseEnter={() => setHoveredBenefit(0)} onMouseLeave={() => setHoveredBenefit(null)} data-id="element-33">
            <div className="w-14 h-14 bg-[#eef2ff] rounded-full flex items-center justify-center mb-6" data-id="element-34">
              <SnowflakeIcon size={28} className={`${hoveredBenefit === 0 ? 'text-[#4ade80] animate-pulse' : 'text-[#6366f1]'}`} data-id="element-35" />
            </div>
            <h3 className="text-xl font-semibold mb-3 text-[#1e293b]" data-id="element-36">
              ❄️ Frío profundo
            </h3>
            <p className="text-[#4a5568]" data-id="element-37">Calma la inflamación</p>
            {hoveredBenefit === 0 && <div className="mt-4 text-sm text-[#4a5568] bg-white p-2 rounded-lg border border-[#e2e8f0] animate-fadeIn" data-id="element-38">
                <strong data-id="element-39">Dato:</strong> El frío reduce la inflamación hasta en un
                68% en los primeros 15 minutos de aplicación.
              </div>}
          </div>
          <div className={`bg-[#f8f9ff] p-8 rounded-xl shadow-md transition-all duration-300 ${hoveredBenefit === 1 ? 'shadow-xl transform scale-105 border-2 border-[#6366f1]' : 'hover:shadow-lg hover:transform hover:scale-105'}`} onMouseEnter={() => setHoveredBenefit(1)} onMouseLeave={() => setHoveredBenefit(null)} data-id="element-40">
            <div className="w-14 h-14 bg-[#eef2ff] rounded-full flex items-center justify-center mb-6" data-id="element-41">
              <FlameIcon size={28} className={`${hoveredBenefit === 1 ? 'text-[#f59e0b] animate-pulse' : 'text-[#6366f1]'}`} data-id="element-42" />
            </div>
            <h3 className="text-xl font-semibold mb-3 text-[#1e293b]" data-id="element-43">
              🔥 Calor opcional
            </h3>
            <p className="text-[#4a5568]" data-id="element-44">Relaja tensión muscular</p>
            {hoveredBenefit === 1 && <div className="mt-4 text-sm text-[#4a5568] bg-white p-2 rounded-lg border border-[#e2e8f0] animate-fadeIn" data-id="element-45">
                <strong data-id="element-46">Dato:</strong> El calor aumenta el flujo sanguíneo hasta
                un 54%, acelerando la recuperación muscular.
              </div>}
          </div>
          <div className={`bg-[#f8f9ff] p-8 rounded-xl shadow-md transition-all duration-300 ${hoveredBenefit === 2 ? 'shadow-xl transform scale-105 border-2 border-[#6366f1]' : 'hover:shadow-lg hover:transform hover:scale-105'}`} onMouseEnter={() => setHoveredBenefit(2)} onMouseLeave={() => setHoveredBenefit(null)} data-id="element-47">
            <div className="w-14 h-14 bg-[#eef2ff] rounded-full flex items-center justify-center mb-6" data-id="element-48">
              <HandIcon size={28} className={`${hoveredBenefit === 2 ? 'text-[#ec4899] animate-pulse' : 'text-[#6366f1]'}`} data-id="element-49" />
            </div>
            <h3 className="text-xl font-semibold mb-3 text-[#1e293b]" data-id="element-50">
              👐 Compresión uniforme
            </h3>
            <p className="text-[#4a5568]" data-id="element-51">Reduce presión craneal</p>
            {hoveredBenefit === 2 && <div className="mt-4 text-sm text-[#4a5568] bg-white p-2 rounded-lg border border-[#e2e8f0] animate-fadeIn" data-id="element-52">
                <strong data-id="element-53">Dato:</strong> La compresión uniforme puede reducir la
                presión craneal hasta en un 47% en casos de migraña.
              </div>}
          </div>
          <div className={`bg-[#f8f9ff] p-8 rounded-xl shadow-md transition-all duration-300 ${hoveredBenefit === 3 ? 'shadow-xl transform scale-105 border-2 border-[#6366f1]' : 'hover:shadow-lg hover:transform hover:scale-105'}`} onMouseEnter={() => setHoveredBenefit(3)} onMouseLeave={() => setHoveredBenefit(null)} data-id="element-54">
            <div className="w-14 h-14 bg-[#eef2ff] rounded-full flex items-center justify-center mb-6" data-id="element-55">
              <MoonIcon size={28} className={`${hoveredBenefit === 3 ? 'text-[#8b5cf6] animate-pulse' : 'text-[#6366f1]'}`} data-id="element-56" />
            </div>
            <h3 className="text-xl font-semibold mb-3 text-[#1e293b]" data-id="element-57">
              🟣 Oscuridad total
            </h3>
            <p className="text-[#4a5568]" data-id="element-58">Bloquea estímulos (luz/pantalla)</p>
            {hoveredBenefit === 3 && <div className="mt-4 text-sm text-[#4a5568] bg-white p-2 rounded-lg border border-[#e2e8f0] animate-fadeIn" data-id="element-59">
                <strong data-id="element-60">Dato:</strong> El 78% de las migrañas empeoran con la
                exposición a la luz. La oscuridad total puede reducir la
                duración del dolor.
              </div>}
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-61">
          <div className="bg-[#f0f9ff] p-4 rounded-lg inline-block mb-6 mx-auto border border-[#bae6fd]" data-id="element-62">
            <p className="text-lg text-[#0284c7] italic" data-id="element-63">
              "El 94% de nuestros usuarios reporta mejoría después de solo 3
              usos"
            </p>
          </div>
          <p className="text-lg text-[#4a5568] italic" data-id="element-64">
            Es como un reinicio para tu sistema nervioso.
          </p>
          <div className="mt-8 relative" data-id="element-65">
            <div className="absolute -inset-1 bg-gradient-to-r from-[#4ade80] to-[#22c55e] blur opacity-30 rounded-full animate-pulse" data-id="element-66"></div>
            <button onClick={handleCTAClick} className="relative bg-[#4ade80] hover:bg-[#22c55e] text-white px-8 py-4 rounded-full text-lg font-medium transition-all transform hover:scale-105 shadow-lg group" data-id="element-67">
              <span className="flex items-center justify-center" data-id="element-68">
                <span className="group-hover:translate-x-1 transition-transform" data-id="element-69">
                  Quiero mi reinicio ahora
                </span>
                <CheckCircleIcon className="ml-2 opacity-0 group-hover:opacity-100 transition-opacity" size={20} data-id="element-70" />
              </span>
            </button>
          </div>
          {/* Testimonios rápidos */}
          <div className="mt-8 flex justify-center" data-id="element-71">
            <div className="inline-flex items-center text-sm text-[#4a5568] bg-white px-4 py-2 rounded-full shadow-sm" data-id="element-72">
              <img src="https://randomuser.me/api/portraits/women/32.jpg" alt="Usuario" className="w-6 h-6 rounded-full mr-2" data-id="element-73" />
              <span data-id="element-74">"Alivio desde el primer uso"</span>
              <span className="mx-2 text-[#d1d5db]" data-id="element-75">•</span>
              <span className="text-[#6366f1]" data-id="element-76">hace 13 minutos</span>
            </div>
          </div>
        </div>
      </div>
      <style jsx data-id="element-77">{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out forwards;
        }
      `}</style>
    </section>;
};
export default memo(Benefits);